import { render, staticRenderFns } from "./TreatmentMixWidget.vue?vue&type=template&id=5a316620&"
import script from "./TreatmentMixWidget.vue?vue&type=script&lang=js&"
export * from "./TreatmentMixWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports